// Feeds Shopify Analytics / Live View from the headless React storefront.
// Because our pages are served by React (not Shopify's Online Store), Shopify
// can't see visitors by default. sendShopifyAnalytics posts page_view events to
// Shopify's analytics pipeline (the same mechanism Hydrogen uses), so sessions
// show up in Shopify admin -> Analytics -> Live View.

import {
  sendShopifyAnalytics,
  getClientBrowserParameters,
  AnalyticsEventName,
  ShopifySalesChannel,
} from '@shopify/hydrogen-react';

const SHOP_ID = 'gid://shopify/Shop/56627626169';
const SHOP_DOMAIN = process.env.REACT_APP_SHOPIFY_DOMAIN || 'berleto-com.myshopify.com';

export function sendPageView() {
  try {
    sendShopifyAnalytics(
      {
        eventName: AnalyticsEventName.PAGE_VIEW,
        payload: {
          ...getClientBrowserParameters(),
          hasUserConsent: true,
          shopId: SHOP_ID,
          currency: 'USD',
          acceptedLanguage: 'EN',
          shopifySalesChannel: ShopifySalesChannel.headless,
        },
      },
      SHOP_DOMAIN,
    );
  } catch (e) {
    /* analytics must never break the app */
  }
}
